module.exports = __webpack_public_path__ + "static/media/smallLogo.bd4f39a7.png";